export const NODE_TYPES = {
    IMAGE: 'image',
    FOLDER: 'folder'
}